import React from "react";
import { Link } from "react-router-dom";
import "./button.css";
export const Button1 = (props) => {
  return (
    <button type={props?.type || "button"} className="main-btn">
      {props?.label}
    </button>
  );
};

export const LinkButton1 = (props) => {
  return (
    <Link
      class="main-btn"
      to={props?.link}
      rel="nofollow"
      onClick={(event) => event.preventDefault()}
    >
      {props?.label}
    </Link>
  );
};

export const Button2 = (props) => {
  return (
    <button type={props?.type || "button"} className="main-btn main-btn-2">
      {props?.label}
    </button>
  );
};

export const LinkButton2 = (props) => {
  return (
    <Link class="main-btn main-btn-2" to={props?.link} rel="nofollow">
      {props?.label}
    </Link>
  );
};
